import { fetchImageResearchedProduct } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ImageResearchedProductKeys = {
    all: ['imageresearchedproduct'] as const,
    lists: () => [...ImageResearchedProductKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ImageResearchedProductKeys.lists(), page, perPage, filters] as const,
    details: () => [...ImageResearchedProductKeys.all, 'detail'] as const,
    detail: (params: string) => [...ImageResearchedProductKeys.details(), params] as const,
}

export const useImageResearchedProductQuery = (DS_CHAVE_ARQUIVO: string, enableStatus: boolean) => {
    return useQuery({
        enabled: enableStatus,
        queryFn: () => fetchImageResearchedProduct(DS_CHAVE_ARQUIVO),
        queryKey: ImageResearchedProductKeys.detail(DS_CHAVE_ARQUIVO),
    })
}
